import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateOptionsLabels } from '../redux/actions/options.action';

/**
 * Хук для автоматического обновления подписей (label) в select-опциях
 * при монтировании компонента — например, после смены языка.
 *
 * Используется для обновления значений, зависящих от i18n.
 */
const useOptionsLabelUpdater = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateOptionsLabels());
  }, [dispatch]);
};

export default useOptionsLabelUpdater;
